import { Box, VStack } from '@chakra-ui/react';

import InputComponent from 'UiKit/input';

import styles from './styles.module.css';

const ChangeHost = ({ hostValue, hostLabel }) => {
  return (
    <Box className={styles['change-host']}>
      <VStack spacing={4} align="stretch">
        <InputComponent className={styles['form-reschedule__input']} label={hostLabel} value={hostValue} isRequired isImmutable />
      </VStack>
    </Box>
  );
};

export default ChangeHost;
